import { trackEvent } from '@/tagmanager/dataLayer';

type TtrackSelectFareClassParams = {
  cabin_name: string;
  link_text: string;
  related_item_id: string;
  selected_tier: string;
};

export const trackOpenFareClassFlyout = () => {
  trackEvent({
    event: 'view_voyage_tier_flyout',
  });
};

export const trackClickBackToCabinOptions = () => {
  trackEvent({
    event: 'click_voyage_tier_flyout_cta1',
    link_text: 'Cabin options',
  });
};

export const trackSelectFareClass = ({
  cabin_name,
  link_text,
  related_item_id,
  selected_tier,
}: TtrackSelectFareClassParams) => {
  trackEvent({
    cabin_name,
    event: 'click_voyage_tier_flyout_cta2',
    link_text,
    related_item_id,
    selected_tier,
  });
};
